import { useState, useEffect, useCallback } from 'react';
import Posts from '../components/Posts'
import 'bootstrap-icons/font/bootstrap-icons.css';
import LoadingIndicator from '../components/LoadingIndicator';
import ErrorPage from '../components/ErrorPage';
import useRole from '../hooks/useRole';

export default function Blog() {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [postsLoaded, setPostsLoaded] = useState(false);
    const { hasRole } = useRole();
    
    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!postsLoaded) {
                setHasError(true);
                setIsLoading(false);
            }
        }, 5000);
        return () => clearTimeout(timeout);
    }, [postsLoaded]);
    
    const handlePostsLoaded = useCallback(() => {
        setPostsLoaded(true);
        setIsLoading(false);
    }, []);
    
    if (hasError) {
        return <ErrorPage msg='Server Error' />
    }
    
    return (
        <div className='blog-page'>
            {
                isLoading && <LoadingIndicator />
            }
            
            {
                !isLoading && (
                    <>
                        <div className='d-flex align-items-center justify-content-center mt-5 mb-6'>
                            <span>
                                <label className='header h1'>Blog</label>
                                <i className="bi bi-body-text h1 me-2"></i>
                            </span>
                            {hasRole(7777) && (
                                <a href="/create-post">
                                    <button 
                                        type="button" 
                                        className="btn btn-outline-dark"
                                    >
                                        Create Post
                                    </button>
                                </a>
                            )}
                        </div>
                    </>
                )
            }
            
            <div style={{ display: isLoading ? 'none' : 'block' }}>
                <Posts onLoaded={ handlePostsLoaded } /> 
            </div>
        </div>
    );
}